var _defs, _rect, _path, _path2, _ellipse, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMasterCard1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Payment_Icons",
    "data-name": "Payment Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#f7f7f7;}.cls-3{fill:#f79e1b;}.cls-4{fill:#ff5f00;}.cls-5{fill:#eb001b;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mastercard-color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.5,
    y: 7.5,
    width: 37,
    height: 23,
    rx: 4.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33,8a4,4,0,0,1,4,4V26a4,4,0,0,1-4,4H5a4,4,0,0,1-4-4V12A4,4,0,0,1,5,8H33m0-1H5a5,5,0,0,0-5,5V26a5,5,0,0,0,5,5H33a5,5,0,0,0,5-5V12a5,5,0,0,0-5-5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27.31,19A4.75,4.75,0,0,1,19,22.14a4.74,4.74,0,0,0,0-6.28A4.75,4.75,0,0,1,27.31,19Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 19,
    cy: 19,
    rx: 1.19,
    ry: 3.14
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M17.81,19A4.76,4.76,0,0,0,19,22.14a4.75,4.75,0,1,1,0-6.28A4.76,4.76,0,0,0,17.81,19Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard1);
export default __webpack_public_path__ + "static/media/master-card-1.9bc98392563a6eef8276899d76fb30e1.svg";
export { ForwardRef as ReactComponent };